import {
    apiRequest,
    angkaKreditDetail,
    angkaKreditApprove
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", angkaKreditDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", angkaKreditApprove, {
            body: query
        }, true)
    }
}

export default DetailRepository